'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SVG = require('./SVG');

var _SVG2 = _interopRequireDefault(_SVG);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MdPhonePortrait = function MdPhonePortrait(props) {
  return _react2["default"].createElement(_SVG2["default"], {
    style: props.style,
    className: props.className,
    fill: props.color,
    width: props.fontSize,
    height: props.fontSize,
    viewBox: '0 0 1024 1024',
    onClick: props.onClick,
    rotate: props.rotate ? 1 : 0,
    shake: props.shake ? 1 : 0,
    beat: props.beat ? 1 : 0
  }, _react2["default"].createElement('path', {
    d: 'M717.712 64h-411.426c-45.262 0-82.286 36.652-82.286 81.456v733.090c0 44.802 37.024 81.454 82.286 81.454h411.426c45.264 0 82.288-36.652 82.288-81.456v-733.088c0-44.804-37.024-81.456-82.288-81.456zM728 800h-432v-576h432v576z'
  }));
};

MdPhonePortrait.defaultProps = {
  // style
  style: {},
  color: '#000000',
  fontSize: '22px',
  // animation
  shake: false,
  beat: false,
  rotate: false
};
MdPhonePortrait.propTypes = {
  // style
  style: _propTypes2["default"].object,
  color: _propTypes2["default"].string,
  fontSize: _propTypes2["default"].string,
  // animation
  shake: _propTypes2["default"].bool,
  beat: _propTypes2["default"].bool,
  rotate: _propTypes2["default"].bool,
  // functions
  onClick: _propTypes2["default"].func
};
exports["default"] = MdPhonePortrait;
module.exports = exports['default'];